export default __webpack_public_path__ + "f0a4bd3f49b6bc901e97ddfe2fd1d656.png";